/** Client for /api/chat (contract: docs/modules/chat.md). */
export const BASE = "/api/chat";

export const PERMISSIONS = {
  use: "chat.use",
  admin: "chat.admin",
} as const;

/** Max characters of a message body (contract). */
export const MAX_BODY = 4000;

/** Messages per page (contract default). */
export const PAGE_SIZE = 50;

/** Query string from the defined, non-empty parameters ("" when there are none). */
export const query = (params: Record<string, string | number | undefined>): string => {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== "") search.set(k, String(v));
  const s = search.toString();
  return s ? `?${s}` : "";
};
